
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 11.5H20V6.95a2.5 2.5 0 10-1 0v4.55H5V4.95a2.5 2.5 0 10-1 0v6.55H.5a.5.5 0 000 1h11v5.55a2.5 2.5 0 101 0V12.5h11a.5.5 0 000-1zm-5.5-7A1.5 1.5 0 1119.5 6 1.5 1.5 0 0118 4.5zm-15-2A1.5 1.5 0 114.5 4 1.5 1.5 0 013 2.5zm10.5 18A1.5 1.5 0 1112 19a1.5 1.5 0 011.5 1.5z"}})])
          )
        }
      }
    